import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';

//import axios from "axios"

//window.MYID=Math.random()

// axios.interceptors.request.use(
//   function(config) {
//     config.headers["X-Requested-With"] = 'XMLHttpRequest';
//     //config.headers["X-Requested-ID"] = window.MYID;
//     return config;
//   },
//   function(error) {
//     return Promise.reject(error);
//   }
// );


// axios.interceptors.response.use((response) => {
    
//     return response;
// }, (error) => {
      
//     if (error.response.status === 401)
//       //window.location.href = "/";
//     //if (error.response.status === 302)
//     //  window.location.href = "./#";  
//      return Promise.reject(error);
// });



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <HashRouter>
      <App />
    </HashRouter>
  
);